import { AuthConnection, Connection } from "./config.js";


function OpenPage(auth_url) {
    let form = document.createElement("form");

    var m = document.createElement("input");
    m.type = "hidden";
    m.name = "m";
    m.value = "checkplusSerivce";

    form.action = auth_url;
    form.target = "_self";
    form.appendChild(m);

    document.body.appendChild(form);
    form.submit();
}

export async function startNiceAuth(form) {
    const { data } = await AuthConnection.post("/nice/auth/request", form);
    OpenPage(data.auth_url);
}

function random_user_id() {
    return Math.floor(Math.random() * 1000000);
}
export async function startNiceNoAuth(form) {
    form.user_id = random_user_id();
    const { data } = await Connection.post("/nice/noauth/request", form);
    OpenPage(data.auth_url);
}